// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { userMixins } from "@/app/mixins/modules/user-mixins.js";

// Util
import { vuelidateUtil } from "@/utils/vuelidate-util.js";

// Services
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js";

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants";

// Third Party libraries
import * as $ from "jquery";


export default {
    name: "ModalDogRequestRefund",
    mixins: [toastMessageMixins, userMixins],
    props: {
        puppySellId: {
            type: Number,
        }
    },
    data() {
        return {
            remarks: "",
            isAPILoading: false,
            order: null,
        };
    },

    computed: {
        validationRules() {
            let field = {
                remarks: {},
            };

            field = vuelidateUtil.setRequiredValidation(field, "remarks");

            return field;
        },

        charactersLeftRemarks() {
            let char = this.remarks.length,
                limit = 255;

            return `${limit - char} / ${limit}`;
        },
    },
    methods: {
        openModal(orderDetails) {
            this.resetFields();
            this.order = orderDetails;
            $(this.$refs.modalRefund).modal("show");
        },
        closeModal() {
            $(this.$refs.modalRefund).modal("hide");
        },
        resetPuppyPurchaseDetails() {
            this.closeModal()
            this.$emit('getPuppyPurchaseDetails');
        },
        resetFields() {
            this.remarks = "";
            this.$v.$reset();
            this.order = null;
        },
        async submitCancellation() {
            if (this.$v.$invalid) {
                return;
            }

            const requestDetails = {
                puppyToSellId: this.puppySellId,
                reason: this.remarks,
            };

            try {
                this.isAPILoading = true;
                const response = await puppySellService.postPuppyRequestRefund(requestDetails)
                if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                    this.showCustomSuccessToast(null, 'Your Request for Refund has been sent!');
                    this.resetPuppyPurchaseDetails();
                    this.resetFields();
                } else {
                    this.showAPIErrorToast('', response)
                }
                this.isAPILoading = false;
            } catch(err) {
                this.isAPILoading = false;
            }

        },
    },
    validations() {
        return this.validationRules;
    },
};
